import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > * + *": {
      marginLeft: theme.spacing(2),
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export default function CircularIndeterminate() {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={true}>
      <div
        className={classes.root}
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          // background:"white",
          // width:"100%",
          // height:"50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <CircularProgress size={60} thickness={3} />
      </div>
    </Backdrop>
  );
}
